import React, { useMemo, useState } from "react";
import { calculateEndOfService } from "../../tools/calculators/endOfServiceCalculator";
import { useLanguage } from "../../contexts/LanguageContext";

const EndOfServiceTool = ({ initialValues = {} }) => {
  const { t } = useLanguage();
  const [form, setForm] = useState({
    monthlySalary: initialValues.monthlySalary || "",
    startDate: initialValues.startDate || "",
    endDate: initialValues.endDate || "",
    terminationType: initialValues.terminationType || "employer",
    contractType: initialValues.contractType || "unlimited",
  });

  const result = useMemo(() => calculateEndOfService(form), [form]);

  const handleChange = (event) => {
    const { name, value } = event.target;
    setForm((prev) => ({ ...prev, [name]: value }));
  };

  return (
    <section className="tools-panel">
      <h2 className="tools-panel-title">{t("tools.eos.title")}</h2>
      <p className="tools-panel-subtitle">
        {t("tools.eos.subtitle")}
      </p>

      <div className="tools-grid">
        <label className="tools-field">
          <span>{t("tools.eos.field.monthlySalary")}</span>
          <input
            type="number"
            min="0"
            name="monthlySalary"
            value={form.monthlySalary}
            onChange={handleChange}
            placeholder={t("tools.eos.placeholder.monthlySalary")}
          />
        </label>

        <label className="tools-field">
          <span>{t("tools.eos.field.startDate")}</span>
          <input type="date" name="startDate" value={form.startDate} onChange={handleChange} />
        </label>

        <label className="tools-field">
          <span>{t("tools.eos.field.endDate")}</span>
          <input type="date" name="endDate" value={form.endDate} onChange={handleChange} />
        </label>

        <label className="tools-field">
          <span>{t("tools.eos.field.terminationType")}</span>
          <select name="terminationType" value={form.terminationType} onChange={handleChange}>
            <option value="employer">{t("tools.eos.option.termination.employer")}</option>
            <option value="resignation">{t("tools.eos.option.termination.resignation")}</option>
            <option value="contract-end">{t("tools.eos.option.termination.contractEnd")}</option>
          </select>
        </label>

        <label className="tools-field">
          <span>{t("tools.eos.field.contractType")}</span>
          <select name="contractType" value={form.contractType} onChange={handleChange}>
            <option value="unlimited">{t("tools.eos.option.contract.unlimited")}</option>
            <option value="fixed">{t("tools.eos.option.contract.fixed")}</option>
          </select>
        </label>
      </div>

      <div className="tools-result-card">
        <div className="tools-result-amount-wrap">
          <span className="tools-result-label">{t("tools.eos.result.estimatedAmount")}</span>
          <strong className="tools-result-amount">
            {result.valid
              ? t("tools.common.currency.sar", { amount: result.amount.toLocaleString("en-US") })
              : "—"}
          </strong>
        </div>
        <p className="tools-result-explanation">
          {result.valid
            ? t("tools.eos.result.explanation", { serviceYears: result.serviceYears, salary: result.salary })
            : t("tools.eos.validation.invalidInput")}
        </p>

        <div className="tools-result-columns">
          <div>
            <h4>{t("tools.eos.result.assumptionsHeading")}</h4>
            <ul>
              {result.assumptionsKeys.map((key) => (
                <li key={key}>{t(key)}</li>
              ))}
            </ul>
          </div>
          <div>
            <h4>{t("tools.eos.result.notesHeading")}</h4>
            <ul>
              {result.notesKeys.map((key) => (
                <li key={key}>{t(key)}</li>
              ))}
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
};

export default EndOfServiceTool;

